import axios from "../../config/axiosConfig";
import {
  CREATE_WORKER_JAMA, DELETE_WORKER_JAMA,
  GET_WORKER_JAMA,
  WORKER_JAMA_REQUEST,
  WORKER_JAMA_REQUEST_FAILURE,
  UPDATE_WORKER_JAMA,
  JAMA_KARIGAR_REQUEST,
  GET_JAMA_KARIGARS,
  JAMA_KARIGAR_REQUEST_FAILURE,
} from "../types/worker-jama-types";

export const getWorkerJama = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WORKER_JAMA_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/worker-jama/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_WORKER_JAMA, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_JAMA_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_JAMA_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createWorkerJama = (workerJama) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: WORKER_JAMA_REQUEST });
      const newWorkerJama = {
        ...workerJama
      };
      return axios.post("/worker-jama/add", newWorkerJama,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_WORKER_JAMA, payload: response.data });
        } else {
          dispatch({
            type: WORKER_JAMA_REQUEST_FAILURE,
            error: "Worker Attendance Monthly create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_JAMA_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_JAMA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateWorkerJama = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WORKER_JAMA_REQUEST });
      const { auth } = getState();
      return axios.put("/worker-jama/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_WORKER_JAMA,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: WORKER_JAMA_REQUEST_FAILURE,
            error: "Worker Attendance Monthly update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_JAMA_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_JAMA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteWorkerJama = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: WORKER_JAMA_REQUEST });
      return axios.delete(`/worker-jama/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_WORKER_JAMA, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_JAMA_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_JAMA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJamaKarigars = (workerJamaId = null) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: JAMA_KARIGAR_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, workerJamaId: workerJamaId };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            return axios.get('/worker-jama/getAllJamaKarigars', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_JAMA_KARIGARS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: JAMA_KARIGAR_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: JAMA_KARIGAR_REQUEST_FAILURE, error: error.message });
        }
    };
};